import { ReactElement, useEffect } from 'react';
import { getLabelFallback } from '@utils/utils';
import { useSelector } from 'react-redux';

import Modal from '@components/Modal';

import Affirm from '@images/svg-icons/affirm_instalments.svg';
import Klarna from '@images/svg-icons/klarna_instalments.svg';

type Props = {
    close: () => void
}

const InstalmentsModal = (props: Props) : ReactElement => {
    
    const {
        close
    } = props;


    useEffect(() => {
        window.affirm.ui.ready(function(){
            window.affirm.ui.refresh();
        });

        window.Klarna.OnsiteMessaging.refresh()
    }, []);

    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);
    const isMobile = useSelector(state => state.cart.isMobile);

    const getInstalments = () => {
        return (
            <div className="instalments-modal-banner">
                <div className="instalments-modal-banner-container">
                    <div className="instalments-modal-banner-image">
                        <img src="https://assets.glasses.com/extra/image/Glasses/LOGOS/affirm_logo.png" srcset="https://assets.glasses.com/extra/image/Glasses/LOGOS/affirm_logo@2x.png 2x, https://assets.glasses.com/extra/image/Glasses/LOGOS/affirm_logo@3x.png 3x" crossorigin="anonymous"></img>							
                    </div>
                    <p className="affirm-as-low-as" data-page-type="cart" data-amount={parseFloat(cart.grandTotal) * 100} data-theme="custom"></p>
                </div>
                {config.klarna.enabled === true && config.klarna.InstallmentEnabled === true &&
                    <div className="instalments-modal-banner-container">
                        {/*<div className='instalments-modal-banner-image no-border'>
                            <Klarna />
                        </div>*/}
                        <klarna-placement class="klarna-placement" data-key="credit-promotion-badge" data-locale="en-US" data-purchase-amount={(parseFloat(cart.grandTotal) * 100).toFixed()}></klarna-placement>
                    </div>
                }
                <div className="instalments-modal-banner-container">
                    {!!isMobile && 
                                        <div class="paypal" data-pp-message data-pp-placement="product" data-pp-amount={parseFloat(cart.grandTotal)} data-pp-style-layout="text" data-pp-style-logo-position="top" data-pp-style-text-align="center" data-pp-style-text-size="14">															    
                                        </div>
                    }
                    {!isMobile && 
                                        <div class="paypal" data-pp-message data-pp-placement="product" data-pp-amount={parseFloat(cart.grandTotal)} data-pp-style-layout="text" data-pp-style-logo-position="left" data-pp-style-text-size="14">															    
                                        </div>
                    }
                </div>
             </div>
        );
    }
    var claim_label  = '';
    isMobile ? claim_label = getLabelFallback('INSTALMENTS_MODAL_CLAIM_MOBILE'): claim_label = getLabelFallback('INSTALMENTS_MODAL_CLAIM');
    return (
      
        <div className="instalments-modal" data-analytics_available_call='0'>
            <Modal
                close={close}
            >
                <div className="instalments-modal">
                    <h2 className="instalments-modal-title">{ getLabelFallback('INSTALMENTS_MODAL_TITLE') }</h2>
                    <span className="instalments-modal-claim" 
                        dangerouslySetInnerHTML={{__html: claim_label
                            .replace('{SITE_NAME}', getLabelFallback('SITE_NAME'))
                            .replace('{AFFIRM_LABEL}', getLabelFallback('AFFIRM_LABEL'))
                            .replace('{OR_KLARNA}', config.klarna.enabled === true && config.klarna.InstallmentEnabled === true ? ',' : '')
                            .replace('{KLARNA_LABEL}', config.klarna.enabled === true && config.klarna.InstallmentEnabled === true ? getLabelFallback('KLARNA_LABEL') : '')
                            .replace('{PAYPAL_PAYMENT_LABEL}', getLabelFallback('PAYPAL_INSTALLMENTS_LABEL'))
                        }}
                    >
                    </span>
                    { getInstalments() }
                </div>
            </Modal>
        </div>
    )
}

export default InstalmentsModal;